import qs from 'qs';
import externalLinks from '../../external-links';
import slugify from 'slugify';

let height_check_loop = null;
let last_height = 0;
const height_check_interval = 500;

const messages = {
    hashchange: handleHashChangeMessage,
    externalLink: handleExternalLink,
    heightChange: handleHeightChange
};

window.addEventListener("message", receiveMessage, false);

onReady(window, function(){
    document.querySelectorAll('iframe.articulate-iframe').forEach( injectRouteEvents );
});

//////////

function injectRouteEvents( element ) {

    onReady(element.contentWindow, iframeReady, [element]);

}

function onReady(context, callback, argArray) {
    if (context.document.readyState === "complete" || (context.document.readyState !== "loading" && !context.document.documentElement.doScroll)) {
        callback.apply(this, argArray);
    } else {
        context.document.addEventListener("DOMContentLoaded", function(){
            callback.apply(this, argArray);
        });
    }
}

function height_check( element ) {
    transmit_current_height( element );
    clearTimeout(height_check_loop);
    height_check_loop = setTimeout(()=>{ height_check(element); }, height_check_interval);
}

function transmit_current_height( element ) {
    const pageWrap = element.contentWindow.document.getElementById('page-wrap');
    const overview = element.contentWindow.document.getElementById('overview');
    let height = 1000;

    if(pageWrap) {
        const pages = element.contentWindow.document.querySelectorAll('#page-wrap > main');
        const page = pages[pages.length - 1];

        height = page.offsetHeight;
    }else if(overview) {
        height = element.contentWindow.document.querySelector('#overview > header').offsetHeight + element.contentWindow.document.querySelector('#overview > main').offsetHeight;
    }else {
        height = element.contentWindow.document.querySelector('body').offsetHeight;
    }

    if(last_height === height) {
        return;
    }else {
        last_height = height;
    }

    if(element && element.contentWindow && element.contentWindow.parent && element.contentWindow.parent.postMessage) {
        element.contentWindow.parent.postMessage({
            action: 'heightChange',
            height: height
        }, '*');
    }else {
        // eslint-disable-next-line
        console.info('missed heightChange');
    }
}

function iframeReady( element ) {

    element.contentWindow.addEventListener('hashchange', function () {
        if(element && element.contentWindow && element.contentWindow.parent && element.contentWindow.parent.postMessage) {
            element.contentWindow.parent.postMessage({
                action: 'hashchange',
                location: JSON.parse(JSON.stringify(element.contentWindow.location)),
                progress: element.contentWindow.Runtime.getProgress()
            }, '*');
        }else {
            // eslint-disable-next-line
            console.info('missed hashChange');
        }
    });

    element.contentWindow.document.body.addEventListener('click', function(event) {

        if(!externalLinks.isExternalLink(event.target, element.contentWindow.document)) {
            return;
        }

        event.preventDefault();

        if(element && element.contentWindow && element.contentWindow.parent && element.contentWindow.parent.postMessage) {
            element.contentWindow.parent.postMessage({
                action: 'externalLink',
                url: event.target.getAttribute('href')
            }, '*');
        }else {
            // eslint-disable-next-line
            console.info('missed externalLink');
        }
    });

    height_check( element );
    // progress_check( element )
}

function receiveMessage( event ) {

    if ((event.origin !== window.location.origin) || !event.data || !event.data.action) {
        return;
    }

    if(messages[event.data.action]) {
        messages[event.data.action].apply(this, [event.data]);
    }
}

function handleHashChangeMessage( data ) {

    const currentSearch = document.location.search.replace(/^\?/, '');
    const currentLesson = qs.parse(currentSearch).lesson;
    const iframeLesson = data.location.hash.replace(/^#\/lessons\//, '');

    if(currentLesson !== iframeLesson) {
        transitionToNewLesson(iframeLesson);
    }

    if(window.hob_lesson_map && window.hob_lesson_map[iframeLesson] && window.hob_course_name) {
        window._paq.push(
            [
                'setCustomUrl',
                window.location.pathname + slugify(window.hob_lesson_map[iframeLesson], {
                    replacement: '-',    // replace spaces with replacement
                    remove: /\./g,        // regex to remove characters
                    lower: true          // result in lower case
                })
            ]
        );
        window._paq.push(['trackPageView', 'Courses - ' + window.hob_course_name + ' - ' + window.hob_lesson_map[iframeLesson]]);
        // window.gtag('config', 'UA-6471741-2', {
        //     'page_title' : 'Courses - ' + window.hob_course_name + ' - ' + window.hob_lesson_map[iframeLesson],
        //     'page_path': window.location.pathname + slugify(window.hob_lesson_map[iframeLesson], {
        //         replacement: '-',    // replace spaces with replacement
        //         remove: /\./g,        // regex to remove characters
        //         lower: true          // result in lower case
        //     })
        // });
    }else if(iframeLesson === '#/') {
        window._paq.push(['setCustomUrl', window.location.pathname + 'outline']);
        window._paq.push(['trackPageView', 'Courses - ' + window.hob_course_name + ' - ' + 'Outline']);
        // window.gtag('config', 'UA-6471741-2', {
        //     'page_title' : 'Courses - ' + window.hob_course_name + ' - ' + 'Outline',
        //     'page_path': window.location.pathname + 'outline'
        // });
    }else {
        window._paq.push(['setCustomUrl', window.location.pathname + '?lesson=' + iframeLesson]);
        window._paq.push(['trackPageView', 'Courses - Unknown (see courses.js)']);
        // window.gtag('config', 'UA-6471741-2', {
        //     'page_title' : 'Courses - Unknown (see courses.js)',
        //     'page_path': window.location.pathname + '?lesson=' + iframeLesson
        // });
    }



}

function transitionToNewLesson( newLessonKey ) {

    if(!newLessonKey) {
        newLessonKey = '';
    }

    const currentSearch = qs.parse(document.location.search.replace(/^\?/, ''));
    currentSearch.lesson = newLessonKey;

    history.replaceState({}, '', '?' + qs.stringify(currentSearch));

}

function handleExternalLink( data ) {

    externalLinks.openExternalLinkModal(data.url);
    
}

function handleHeightChange( data ) {

    const iframe = document.querySelector('iframe.articulate-iframe');
    iframe.setAttribute('height', data.height);

}



// WEBPACK FOOTER //
// ./src/layout/courses/courses.js